import { useState, useEffect, useRef } from "react";
import { haptic } from "@/utils/feedback";

export function Confetti({ show }) {
  const [particles, setParticles] = useState([]);
  const hasTriggeredRef = useRef(false);
  
  useEffect(() => {
    if (show && !hasTriggeredRef.current) {
      hasTriggeredRef.current = true;
      const colors = ['#006A4D', '#C5A059', '#34D399', '#FCD34D', '#818CF8'];
      const newParticles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        left: (i * 17 + 3) % 100,
        delay: (i * 0.04) % 2,
        color: colors[i % colors.length],
        size: 6 + (i % 6),
        isRound: i % 2 === 0
      }));
      setTimeout(() => {
        setParticles(newParticles);
        haptic.success();
      }, 0);
      
      const timer = setTimeout(() => setParticles([]), 4000);
      return () => clearTimeout(timer);
    }
  }, [show]);
  
  if (!show || particles.length === 0) return null;
  
  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {particles.map((p) => (
        <div
          key={p.id}
          className="absolute animate-confetti"
          style={{
            left: `${p.left}%`,
            top: -20,
            width: p.size,
            height: p.size,
            backgroundColor: p.color,
            animationDelay: `${p.delay}s`,
            borderRadius: p.isRound ? '50%' : '0%'
          }}
        />
      ))}
    </div>
  );
}
